import * as React from "react";
import { connect } from "react-redux";

import Bank from "../../screens/Settings/Bank/Bank";
import {
  fetchBanks,
  AddBank,
  EditBank,
  bankSearch,
  bankSlectedPage
} from "./action";
class BankContainer extends React.Component<Props, State> {
  render() {
    return (
      <Bank
        fetchBanks={this.props.fetchBanks}
        BankList={this.props.BankList}
        AddBank={this.props.AddBank}
        EditBank={this.props.EditBank}
        bankSearchList={this.props.bankSearchList}
        bankSearch={this.props.bankSearch}
        bankSlectedPage={this.props.bankSlectedPage}
        BankCount={this.props.BankCount}
        bankSearchCount={this.props.bankSearchCount}
      />
    );
  }
}
function bindAction(dispatch) {
  return {
    fetchBanks: () => {
      dispatch(fetchBanks());
    },
    AddBank: value => {
      // console.log(value);
      dispatch(AddBank(value));
    },
    EditBank: value => {
      dispatch(EditBank(value));
    },
    bankSearch: (value) => {
      dispatch(bankSearch(value));
    },
    bankSlectedPage: value => {
      dispatch(bankSlectedPage(value));
    }
  };
}
const mapStateToProps = state => {
  return {
    BankList: state.BankReducer.BankList,
    BankCount: state.BankReducer.BankCount,
    bankSearchList: state.BankReducer.bankSearchList,
    bankSearchCount: state.BankReducer.bankSearchCount,
  };
};

export default connect(
  mapStateToProps,
  bindAction
)(BankContainer);
